import request from 'services/request';

export async function usersMassiveUpload({ cancelToken, data }) {
  let uri = `/Users/Api/v1/Users/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
